<template>
    <div style="display: inline-block;">
        <span @click.stop="showView">
            <slot></slot>
        </span>

        <el-dialog
            :visible.sync="visible"
            :append-to-body="true"
            :custom-class="$style.dialog"
            :title="order_id == null? '添加商品到购物车' : '添加商品到订单列表'"
        >
        <!-- <p @click="fang()">刷新</p> -->
            <pro-option
                :type="1"
                :list="list"
                :goods_id="goods_id"
                :getCartProducts="getCartProducts"
                :fang = "fang"
                :visible.sync="visible"
            ></pro-option>
        </el-dialog>
    </div>
</template>
<script>
    import Vue from 'vue';
    import ProOptions from '../../components/Common/ProOptions.vue';

    Vue.component('pro-option', ProOptions);
    export default {
        props: ['goods_attr_list', 'goods_id', 'getCartProducts'],

        data () {
            return {
                order_id:localStorage.getItem('order_id'),
                visible: false,
                // list: (this.goods_attr_list || []).map(item => ({ ...item, currId: item.values[0].id}))
                list:(this.goods_attr_list || []).map(item => ({ ...item, currId: item.values[0].id}))
            };

        },
        methods:{
            // fang(){

            //      this.list=(this.goods_attr_list || []).map(item => ({ ...item, currId: item.values[0].id}))
            //     console.log(this.goods_attr_list);
            //     },

                showView(){
                 this.visible=true;
                 this.list=(this.goods_attr_list || []).map(item => ({ ...item, currId: item.values[0].id}))
                }
        },
        // mounted(){
        //     this.fang()
        // }
        
    };


</script>

<style lang="less" module>
    .dialog {
        width: 600px;
        :global(.el-dialog__header) {
            display: flex;
            justify-content: center;
            border-bottom: 1px solid #C7C7C7;
        }
        :global(.el-dialog__body) {
            padding: 30px 90px 30px 70px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/AddPro/Dialog.vue